// noinspection DuplicatedCode

import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinKegiatan = createAsyncThunk(
    "kegiatan/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMinMasterKegiatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getKegiatan = createAsyncThunk(
    "kegiatan/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getMasterKegiatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertKegiatan = createAsyncThunk(
    "kegiatan/insert",
    async ({KelompokKegiatanID, SubKegiatanID, SatuanID, NamaKegiatan, MinUsage, Rate}, thunkAPI) => {
        let formData = new FormData();
        formData.append("KelompokKegiatanID", KelompokKegiatanID);
        formData.append("SubKegiatanID", SubKegiatanID);
        formData.append("NamaKegiatan", NamaKegiatan);
        formData.append("MinUsage", MinUsage);
        formData.append("SatuanID", SatuanID);
        formData.append("Rate", Rate);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertMasterKegiatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateKegiatan = createAsyncThunk(
    "kegiatan/update",
    async ({
               KelompokKegiatanID,
               SubKegiatanID,
               SatuanID,
               NamaKegiatan,
               MinUsage,
               Rate,
               KegiatanID,
               status
           }, thunkAPI) => {
        let formData = new FormData();
        formData.append("KelompokKegiatanID", KelompokKegiatanID);
        formData.append("SubKegiatanID", SubKegiatanID);
        formData.append("NamaKegiatan", NamaKegiatan);
        formData.append("MinUsage", MinUsage);
        formData.append("SatuanID", SatuanID);
        formData.append("Rate", Rate);
        formData.append("KegiatanID", KegiatanID);
        formData.append("status", status);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateMasterKegiatan',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const kegiatanSlice = createSlice({
    name: "kegiatan",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinKegiatan.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinKegiatan.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinKegiatan.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getKegiatan.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getKegiatan.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getKegiatan.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertKegiatan.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertKegiatan.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertKegiatan.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateKegiatan.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateKegiatan.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateKegiatan.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const kegiatanSelector = (state) => state.kegiatan;
